import "./whatsapp.css" 
import React from 'react';


const WhatsappButton = () => {
  return (
    <div className="whatsapp-container">
      <a
        href="https://wa.me/573132872428"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="tooltip">Comunícate</span>
        <img
          src={require('../assets/whatsapp-icon.jpg')}
          alt="WhatsApp"
          className="whatsapp-icon"
        />
      </a>
    </div>
  );
};

export default WhatsappButton;
